import { mapActions, mapGetters } from 'vuex';
import { OrderLayoutEvent } from '../order-layout-bus';

export default {
    data() {
        return {
            cell: { color: '' },
            items: [],
            itemType: null,
            query: null,
            pagination: {
                page: 1,
                perPage: 10,
            },
            useFilter: true,
            usePagination: true,
        };
    },

    mounted() {
        OrderLayoutEvent.$on(`add-${this.itemType}-cell`, grid => {
            this.$refs.modal.$emit('show');
            this.setCell(
                this.getPageCellByGrid(
                    this.activePage.id,
                    grid.x,
                    grid.y,
                    true,
                ),
            );

            this.setItems([]);
        });
    },

    computed: {
        ...mapGetters('orderLayout', [
            'orderLayout',
            'activePage',
            'getPageCellByGrid',
            'getNextEmptyGrid',
            'activeGroupId',
            'getGroupPages',
            'getNextPageWithEmptyGrid',
        ]),
    },

    methods: {
        ...mapActions('orderLayout', ['setOrCreatePageCell', 'addPage']),

        setCell(cell) {
            this.cell = Object.assign({}, cell);
        },

        setItemType(type) {
            this.itemType = type;
        },

        setItems(items) {
            this.items = items;
        },

        setPage(page) {
            this.pagination.page = page;
        },

        async addItems() {
            let page_id = this.activePage.id,
                x = this.cell.x,
                y = this.cell.y;

            this.items.forEach((item, index) => {
                let cell;

                if (!index) {
                    cell = Object.assign(
                        {},
                        this.cell,
                        this.prepareCellAttribute(item, page_id),
                    );
                } else {
                    let nextGrid = this.getNextEmptyGrid(page_id, x, y);
                    // if no grid available for the current page
                    if (_.isNil(nextGrid)) {
                        const nextPage = this.getNextPageWithEmptyGrid(
                            page_id,
                            this.activeGroupId,
                        );

                        // if no next page available with empty grid
                        if (!_.isNil(nextPage)) {
                            page_id = nextPage.page_id;
                            nextGrid = nextPage;
                        } else {
                            this.addPage({ group_id: this.activeGroupId });
                            page_id = _.last(
                                this.getGroupPages(this.activeGroupId),
                            ).id;
                            nextGrid = { x: 0, y: 0 };
                        }
                    }

                    const nextCell = this.getPageCellByGrid(
                        page_id,
                        nextGrid.x,
                        nextGrid.y,
                        true,
                    );

                    cell = _.merge(
                        nextCell,
                        this.prepareCellAttribute(item, page_id),
                    );

                    x = nextGrid.x;
                    y = nextGrid.y;
                }

                this.setOrCreatePageCell(cell);
                this.$emit('cell-added', cell);
            });

            this.$refs.modal.$emit('hide');
        },

        prepareCellAttribute(item, page_id) {
            return {
                page_id,
                action: item,
                action_type: this.itemType,
                action_id: item.id,
            };
        },

        toggleItem(item) {
            if (!this.items.find(i => i.id == item.id)) {
                this.items.push(item);
            } else {
                this.items.splice(
                    _.findIndex(this.items, i => i.id == item.id),
                    1,
                );
            }
        },

        addSelectedItems(items) {
            items.forEach(item => {
                if (!this.items.find(i => i.id == item.id)) {
                    this.items.push(item);
                }
            });
        },

        removeSelectedItems(items) {
            items.forEach(item => {
                if (!!this.items.find(i => i.id == item.id)) {
                    this.items.splice(
                        _.findIndex(this.items, i => i.id == item.id),
                        1,
                    );
                }
            });
        },

        itemAdded(item) {
            return !!this.items.find(i => i.id == item.id);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/order-layout/mixins/order-layout-add-cell.js